export const overline = "font-accent text-xs sm:text-sm uppercase tracking-[0.25em] text-primary";
export const inputClass = "w-full bg-transparent border-b border-border/60 focus:border-primary focus:outline-none rounded-none px-0 py-3 font-body text-foreground placeholder:text-muted-foreground/70 transition-colors duration-300";
export const labelClass = "font-accent text-[11px] uppercase tracking-[0.2em] text-muted-foreground";

export const StepHeading = ({ n, title, hint }) => (
  <div className="mb-8">
    <p className={overline}>{String(n).padStart(2, "0")}</p>
    <h2 className="mt-3 font-headings text-3xl sm:text-4xl leading-[1.15] tracking-tight text-foreground">{title}</h2>
    {hint ? <p className="mt-3 font-body font-light text-sm text-foreground/60">{hint}</p> : null}
  </div>
);

export const BriefRow = ({ label, value, testId }) => (
  <div className="border-t border-border/50 pt-3">
    <dt className={labelClass}>{label}</dt>
    <dd data-testid={testId} className="mt-1 font-body text-sm text-foreground/85">{value}</dd>
  </div>
);
